module.exports = __webpack_public_path__ + "img/3F4441_D1D7D6_888F87_A2ADA1-256px.2bd2d92e.png";